<h4>{{title}}</h4>

<form
    id="analysisForm"
    name="analysisForm"
    novalidate
    autocomplete="off"
    #analysisForm="ngForm">
    <!--Former Tenure-->
    @if (formerTenureDependenciesFound) {
        <div
            id="analysis-former-tenure-dependencies"
            class="container-fluid well"
            data-test-automation="analysis-former-tenure-dependencies">
            <dependencies
                class="group"
                [title]="getPlanModel().planPurpose.name === 'Interest Only' ? 'Affected tenure dependencies' : 'Former tenure dependencies'"
                [dependencyType]="'FORMER_TENURE'"
                [displayConfig]="['tenure']">
            </dependencies>
        </div>
    }

    <!--Descendant Dependencies-->
    @if (descendantDependenciesFound) {
        <div
            id="analysis-descendant-dependencies"
            class="container-fluid well">
            <dependencies
                class="group"
                [title]="'Descendant dependencies'"
                [dependencyType]="'DESCENDANT'"
                [displayConfig]="['tenure', 'parentPlan']">
            </dependencies>
        </div>
    }

    <!--Spatial Dependencies-->
    @if (spatialDependenciesFound) {
        <div
            id="analysis-spatial-dependencies"
            class="container-fluid well">
            <dependencies
                class="group"
                [title]="'Spatial dependencies'"
                [dependencyType]="'SPATIAL'"
                [displayConfig]="['tenure']">
            </dependencies>
        </div>
    }

    <!--Strata Dependencies -->
    @if (strataPlanDependenciesFound) {
        <div
            id="analysis-strata-dependencies"
            class="container-fluid well">
            <dependencies
                class="group"
                [title]="'Scheme Plan dependencies'"
                [dependencyType]="'STRATA'"
                [displayConfig]="['conversionNumber']">
            </dependencies>
        </div>
    }

    <div class="button-group">
        <button
            id="saveAnalysisPageBtn"
            type="button"
            class="btn btn-default nlr-btn-sm validate"
            title="Save Analysis page data | Ctrl+S"
            (click)="save()"
            [disabled]="saveDisabled()">
            Save
            <i
                class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                style="display: none;"></i>
        </button>

        <button
            id="validateAnalysisPageBtn"
            type="button"
            class="btn btn-default nlr-btn-sm validate"
            title="Validate Analysis page data | V"
            (click)="validate()"
            [disabled]="validateDisabled()">
            Validate
            <i
                class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                style="display: none;"></i>
        </button>

        <button
            id="cancelAnalysisTabBtn"
            type="button"
            class="btn btn-warning nlr-btn-sm"
            title="Clears all data on the Analysis screen"
            (click)="cancel()"
            [disabled]="cancelDisabled()">
            Cancel
        </button>
    </div>
</form>
